import { render, staticRenderFns } from "./select-periodos.vue?vue&type=template&id=4616bba2&"
import script from "./select-periodos.vue?vue&type=script&lang=js&"
export * from "./select-periodos.vue?vue&type=script&lang=js&"
import style0 from "./select-periodos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports